var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_8f020e0e"]},_vm.$listeners),[_c('div',[_c('cube-button',{on:{"_click":_vm.showPickerWithUpdate}},[_vm._v("Use updateData")]),_c('cube-picker-modal',{ref:"__mpx_ref_picker__",attrs:{"title":"更新数据","list":(_vm.dataList),"selected-index":(_vm.selectedIndex)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }